module.exports = {
  __depends__: [
    require(215),
    require(80)
  ],
  __init__: [ 'replaceMenuProvider' ],
  replaceMenuProvider: [ 'type', require(73) ]
};